import * as React from "react";
import { BackgroundImageWrapper } from "../../../../../components";
import { PreLiveTeamLeft, PreLiveTeamRight } from "../../components";
export const PreLiveScoreboard = (props) => {
    const { team1Name, team2Name, startEventDate, versus, title, backgroundImage } = props;
    return (React.createElement(BackgroundImageWrapper, { style: { backgroundImage: `url(${backgroundImage})` }, className: "rj-scoreboard__pre-live-wrapper" },
        React.createElement("section", { className: "rj-scoreboard__pre-live-container", "data-uat": "scoreboard-pre-live-container" },
            React.createElement(PreLiveTeamLeft, { teamName: team1Name }),
            React.createElement("span", { className: "rj-scoreboard__pre-live-versus" }, versus),
            React.createElement("div", { className: "rj-scoreboard__pre-live-date-league", "data-uat": "scoreboard-pre-live-date-league" },
                React.createElement("span", { className: "rj-scoreboard__pre-live-date" }, startEventDate),
                React.createElement("span", { className: "rj-scoreboard__pre-live-league" }, title)),
            React.createElement(PreLiveTeamRight, { teamName: team2Name }))));
};
//# sourceMappingURL=PreLiveScoreboard.js.map